// P-08 live updates (D-44; API.md §4.7 "Live updates"; Frontend §4.9): which times of the picked day another patient
// took between two answers of the same week. Generalises the mockup's `takenStart` (patient/steps.tsx `DateTimeStep`)
// to every time that disappears.
import type { WeekAvailability } from '@pa/api/public'

/** One answer of `GET …/availability`, with the query it answered (location, visit type, provider, week). */
export interface WeekSnapshot {
  key: string
  week: WeekAvailability
}

/**
 * The starts on `day` that were in `prev` and are missing from `next`, oldest first. Nothing when the two answers
 * are for different queries or weeks (a week or choice change isn't a live update), or when no day is picked.
 */
export function disappeared(prev: WeekSnapshot | null, next: WeekSnapshot, day: string | null): string[] {
  if (!prev || day === null || prev.key !== next.key || prev.week.weekStart !== next.week.weekStart) return []
  const before = prev.week.days.find((d) => d.date === day)?.slots ?? []
  const now = new Set((next.week.days.find((d) => d.date === day)?.slots ?? []).map((s) => s.start))
  return before.map((s) => s.start).filter((start) => !now.has(start))
}
